export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00802.6e2890dc.png";